import {type AgentSubType, Concept} from 'types';

export const AgentTypes: AgentSubType[] = [
  Concept.person,
  Concept.corporation,
  Concept.publisher,
  Concept.event,
];
